import { apiClient } from "./core/client";
import type { CustomerDto, VehicleDto, PaginatedResponse } from "@/types/dto";

export interface CreateCustomerPayload {
  firstName: string;
  lastName: string;
  email?: string | null;
  phone?: string | null;
  address?: { street?: string; city?: string; state?: string; zip?: string } | null;
  notes?: string | null;
}

export type UpdateCustomerPayload = Partial<CreateCustomerPayload>;

export interface CustomerWithVehicles extends CustomerDto {
  vehicles: VehicleDto[];
}

export async function getCustomers(params?: {
  page?: number;
  limit?: number;
  search?: string;
}) {
  const { data } = await apiClient.get<PaginatedResponse<CustomerDto>>(
    "/api/customers",
    { params }
  );
  return data;
}

export async function getCustomer(id: string) {
  const { data } = await apiClient.get<CustomerWithVehicles>(
    `/api/customers/${id}`
  );
  return data;
}

export async function createCustomer(payload: CreateCustomerPayload) {
  const { data } = await apiClient.post<CustomerDto>("/api/customers", payload);
  return data;
}

export async function updateCustomer(
  id: string,
  payload: UpdateCustomerPayload
) {
  const { data } = await apiClient.patch<CustomerDto>(
    `/api/customers/${id}`,
    payload
  );
  return data;
}

export async function deleteCustomer(id: string) {
  await apiClient.delete(`/api/customers/${id}`);
}
